import { createEntityAdapter } from '@reduxjs/toolkit'
import { IModel } from '../../types'

export const modelsAdapter = createEntityAdapter<IModel>()